import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {TheRave} from "../TheRave";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TheRaveGameMode} from "./TheRaveGameMode";
import {TimelineLite} from "gsap";
import {TheRaveEnhancerReelController} from "../reels/TheRaveEnhancerReelController";
import {TheRaveSound} from "../sound/TheRaveSound";

export class TheRaveFreespinIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    public async start(flowStateController: FlowStateController) {
        const tl: TimelineLite = new TimelineLite();

        TheRave.xwaysEqView.stackedStartPlayed = false;

        TheRave.enhancerReels.forEach((reel: TheRaveEnhancerReelController, reelId: number) => {
            reel.reelView.setPosition(3);
            reel.replaceSymbol("X");
        });
        if (TheRave.model.isRestore) {
            TheRave.model.parsedInitData.splitDataListxWays.forEach((data, i) => {
                const symbolPosition: number[] = data.symbolPostion,
                    reel: number = symbolPosition[0],
                    symbol: number = symbolPosition[1];
                TheRave.reels[reel].restoreXwaySymbols(symbol, data.symName, data.splitNumber);
            });

            TheRave.model.parsedInitData.reels.forEach((syms, reelId) => {
                const xsId: number = syms.indexOf("XS");
                if (xsId > 0 && xsId < 4) {
                    TheRave.reels[reelId].getSymbol(0).restoreXS(1, false, 0);
                    TheRave.reels[reelId].getSymbol(1).restoreXS(1, false, 0);
                    TheRave.reels[reelId].getSymbol(2).restoreXS(1, false, 0);
                }
            });
            TheRave.ways.onRestore();
            TheRave.stickySymbol.onRestore();
            await new Promise<void>(resolve => {
                switch (TheRave.model.parsedInitData.nextMode) {
                    case GameMode.FREESPIN:
                        TheRave.freespinIntro.show(resolve);
                        break;
                    case TheRaveGameMode.FREESPIN_SUPER:
                        TheRave.freespinIntro.show(resolve);
                        break;
                    default:
                        debugger;
                        throw new Error(`TheRaveFreespinIdlePresentation, wrong restore game mode!`);
                }
            });
            SlotGame.keypadPlugin.setZeroBetSpinCounter(TheRave.model.parsedInitData.freespinsLeft - 1);
            if(TheRave.model.parsedInitData.totalWin>0 || TheRave.apiPlugin.freeBets.hasFreeBets()){
                SlotGame.keypadPlugin.setWin(TheRave.model.parsedInitData.totalWin, true, TheRave.isWinBelowStake());
            }
        } else {
            TheRave.model.parsedGameData.enhancerReel.forEach((hasEnhancer: boolean, i: number) => {
                if (hasEnhancer) {
                    TheRave.enhancerReels[i].reelView.playUnLock(i);
                }
            });
            if (TheRave.model.isFreespin) {
                TheRave.model.parsedGameData.scatterPositions.forEach((scatterPosition: number, i: number) => {
                    if (scatterPosition > -1) {
                        TheRave.enhancerReels[i].reelView.playUnLock(i);
                        TheRave.enhancerReels[i].reelView.updateGlow(true);
                        if(TheRave.model.nextMode!=TheRaveGameMode.FREESPIN_SUPER){
                            TheRaveSound.switchMusic(
                                {name: "bgFs2", volume: 1},
                                {name: "bgFs2", from: 1, to: 1, duration: 0},
                                {name:TheRaveSound.FREESPIN_GAME_MUSIC, from: 1, to: 0, duration: 300},
                            );
                        }
                    }
                });
            }
            TheRave.stickySymbol.setAllMultiplierInActive();
            SlotGame.keypadPlugin.setZeroBetSpinCounter(TheRave.model.parsedGameData.freespinsLeft - 1);
        }
        tl.add(() => SlotGame.apiPlugin.betHandler.zeroBet(), 1);
        tl.add(() => flowStateController.finish(), 1);
    }
}
